module.exports = "/_next/static/images/boat-powered-logo-2118c2a6dca8957539348ede9748dbe0.svg";